import {
  CREATE_TEAM,
  GET_TEAM,
  CREATE_TEAM_LABEL,
  UPDATE_TEAM,
  UPDATE_TEAM_PHOTO
} from 'actions/Types';
import { matchPath } from 'react-router';
import Paths from 'AppPaths';

export default (state = null, action) => {
  //If we have a match on the team or user dash, we should clear the existing team
  //before loading the next
  if (action.type === '@@router/LOCATION_CHANGE') {
    const pathName = action.payload.location.pathname;

    const teamMatch = matchPath(pathName, {
      path: Paths.TeamDash,
      exact: true
    });

    const userMatch = matchPath(pathName, {
      path: Paths.UserDash,
      exact: true
    });

    //Only clear the team if it changed
    if (teamMatch && state && teamMatch.params.teamId !== state._id) {
      return null;
    }

    if (userMatch) {
      return null;
    }
  }

  if (action.type === `${CREATE_TEAM}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${GET_TEAM}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${UPDATE_TEAM}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${CREATE_TEAM_LABEL}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${UPDATE_TEAM_PHOTO}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
